import {
  BEAR_CATEGORY,
  DADDY_CATEGORY,
  S3_BUCKET_URL,
  SPORTY_CATEGORY,
  TWINK_CATEGORY,
} from '@/constants.ts';
import {
  SETTING_SELECTOR_IMAGES,
  GREAT_CHOICE_IMAGES,
} from '@/pages/Onboarding/options/SettingSelector/SETTING_SELECTOR_OPTIONS';

import { BREAST_SIZE_OPTIONS } from '../../options/BreastSize/BREAST_SIZE_OPTIONS';
import { BUTT_SIZE_OPTIONS } from '../../options/ButtSize/BUTT_SIZE_OPTIONS';

import { ScreenAboutLook } from './screens/AboutLook';
import { ScreenActingTonight } from './screens/ActingTonight';
import { ScreenAge } from './screens/Age';
import { ScreenBodyShape } from './screens/BodyShape';
import { ScreenBreastSize } from './screens/BreastSize';
import { ScreenButtSize } from './screens/ButtSize';
import { ScreenEmail } from './screens/Email';
import { ScreenEthnicity } from './screens/Ethnicity';
import { ScreenGender } from './screens/Gender';
import { ScreenGreatChoice } from './screens/GreatChoice';
import { ScreenHairColor } from './screens/HairColor';
import { ScreenName } from './screens/Name';
import { ScreenPersonality } from './screens/Personality';
import { ScreenSettingSelector } from './screens/SettingSelector';
import { ScreenSettingUpProfile } from './screens/SettingUpProfile';
import { ScreenTimeOfNight } from './screens/TimeOfNight';
import { ScreenTwistGenerator } from './screens/TwistGenerator';
import { ScreenVibeCheck } from './screens/VibeCheck';
import { WelcomeScreen } from './screens/Welcome';
import { LayoutDataType } from './types';

export const layoutSteps = {
  welcome: {
    component: WelcomeScreen,
    images: [],
  },
  gender: {
    component: ScreenGender,
    images: [],
  },
  age: {
    component: ScreenAge,
    images: [],
  },
  ethnicity: {
    component: ScreenEthnicity,
    images: [],
  },
  hair_color: {
    component: ScreenHairColor,
    images: [],
  },
  body_shape: {
    component: ScreenBodyShape,
    images: [],
  },
  breast_size: {
    component: ScreenBreastSize,
    images: BREAST_SIZE_OPTIONS.map(
      (option) =>
        `${S3_BUCKET_URL}/layout-own-ai-ons/breast-size/${option.id}.jpg`,
    ),
  },
  butt_size: {
    component: ScreenButtSize,
    images: BUTT_SIZE_OPTIONS.map(
      (option) =>
        `${S3_BUCKET_URL}/layout-own-ai-ons/butt-size/${option.id}.jpg`,
    ),
  },
  about_look: {
    component: ScreenAboutLook,
    images: [
      `${S3_BUCKET_URL}/layout-own-ai-man/bg-about-look.png`,
      `${S3_BUCKET_URL}/layout-own-ai/bg-about-look.png`,
    ],
  },
  name: {
    component: ScreenName,
    images: [],
  },
  personality: {
    component: ScreenPersonality,
    images: [],
  },
  setting_selector: {
    component: ScreenSettingSelector,
    images: SETTING_SELECTOR_IMAGES.map((option) => option.spriteSrc),
  },
  great_choice: {
    component: ScreenGreatChoice,
    images: GREAT_CHOICE_IMAGES.map((option) => option.spriteSrc),
  },
  time_of_night: {
    component: ScreenTimeOfNight,
    images: [],
  },
  vibe_check: {
    component: ScreenVibeCheck,
    images: [],
  },
  acting_tonight: {
    component: ScreenActingTonight,
    images: [],
  },
  twist_generator: {
    component: ScreenTwistGenerator,
    images: [],
  },
  setting_up_profile: {
    component: ScreenSettingUpProfile,
    images: [],
  },
  email: {
    component: ScreenEmail,
    images: [],
  },
};

export const layoutStepsKeys = Object.keys(layoutSteps);

export const layoutDataDefault: LayoutDataType = {
  gender: null,
  age: null,
  hair_color: null,
  ethnicity: null,
  body_shape: null,
  breast_size: null,
  butt_size: null,
  acting_tonight: null,
  personality: null,
  time_of_night: null,
  vibe_check: null,
  twist_generator: null,
  setting_selector: null,
  name: '',
  email: '',
};

export const HARDCODED_CATEGORIES = [
  BEAR_CATEGORY,
  TWINK_CATEGORY,
  SPORTY_CATEGORY,
  DADDY_CATEGORY,
];
